export const LOAD_ENVIRONMENT_PROPERTIES = 'portal/LOAD_ENVIRONMENT_PROPERTIES';
export const SET_GLOBAL_HTTP_ERROR = 'portal/SET_GLOBAL_HTTP_ERROR';
export const TIMESERIES_LIMITS = '/timeseries/limits';

export const minimumSupportedWindowWidth = 1024;
export const portraitModeNotSupportedText = `For the intended user experience within the portal, the minimum screen width must be 1024 pixels.
You now switched your view to a lesser width therefore we cannot guarantee a good interaction with the portal anymore.
We recommend you to go back to a bigger screen size (e.g. on tablets switch to landscape mode, change your browser size to full screen, etc.)`;
